<template>
  <div width="100">
    <v-card height="250" class="rounded-lg">
      <v-img
        @click="openLink(data.id)"
        style="cursor: pointer"
        :src="data.img"
        height="250"
        width="250"
        cover
      ></v-img>
    </v-card>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "PartnerCard",
  props: {
    data: Object,
  },
  methods: {
    openLink(data) {
      this.$router.push(`/game/${data}`);
    },
  },
};
</script>
